// extracted by mini-css-extract-plugin
export default {"rootEmergency":"emergencyContact_rootEmergency__IoSMr","konekCard":"emergencyContact_konekCard__jzumd","rootPopBody":"emergencyContact_rootPopBody__1HqtI"};